import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import momentLocalizer from 'react-widgets-moment';
import adicionarFiltro from '../../actions/agencia/adicionarFiltroAgencia'
import removerFiltro from '../../actions/agencia/removerFiltroAgencia'
import FiltroBusca from '../comum/FiltroBusca'
import 'react-widgets/dist/css/react-widgets.css';

momentLocalizer();

export class FiltroBuscaAgencia extends Component {
  render () {
    if (!this.props.filtrosAdicionados) {
      return <div>Carregando...</div>
    }
    return (
      <FiltroBusca
        filtrosAdicionados={this.props.filtrosAdicionados}
        filtro={this.props.filtro}
        opcoes={this.props.opcoes}
        isRadio={this.props.isRadio}
        isFiltroData={this.props.isFiltroData}
        adicionarFiltro={this.props.adicionarFiltro}
        removerFiltro={this.props.removerFiltro}
      />
    )
  }
}

export const mapStateToProps = state => ({
  filtrosAdicionados: state.filtrosAdicionadosAgencia
})

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    adicionarFiltro,
    removerFiltro,
  }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(FiltroBuscaAgencia)
